module.exports = __webpack_public_path__ + "static/media/magnit.59443c0b.svg";